export type WeekDay = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";

export const WEEK_DAY_DROPDOWN: { id: number; key: WeekDay; value: string }[] = [
    { id: 1, key: "mon", value: "월" },
    { id: 2, key: "tue", value: "화" },
    { id: 3, key: "wed", value: "수" },
    { id: 4, key: "thu", value: "목" },
    { id: 5, key: "fri", value: "금" },
    { id: 6, key: "sat", value: "토" },
    { id: 7, key: "sun", value: "일" },
];

export const WEEK_DAY_KOR: Record<string, string> = {
    mon: "월",
    tue: "화",
    wed: "수",
    thu: "목",
    fri: "금",
    sat: "토",
    sun: "일",
};

// 강의 목록 조회
export interface LectureClassScheduleDto {
    weekDay: WeekDay;
    startTime: string; // 12:00:00
    endTime: string; // 14:00:00
}

export interface LectureClassDto {
    no: number;
    title: string;
    productNo: number; // 상품 고유 번호 (가격)
    productName: string; // 상품명 (상품 노출명)
    productCode: string; // 상품 코드
    price: number; // 판매 가격
    priceIncludedVat: number; // 판매 가격에 포함된 부가세
    displayDescription: string; // 상품 노출용 설명(HTML)
    instructor: string;
    location: string;
    capacity: number;
    sessionCount: number;
    recommendTarget: string;
    startDate: string; // 2026-07-01
    endDate: string; // 2026-09-30
    benefitStartAt: string; // 혜택 적용 시작일자 (2026-06-15 00:00:00)
    benefitEndAt: string; // 혜택 적용 종료일자 (2026-06-30 23:59:59)
    schedules: LectureClassScheduleDto[];
}

export interface LectureListDto {
    no: number;
    title: string;
    contents: string;
    order: number;
    createdAt: string; // 2026-06-12
    classes: LectureClassDto[];
}

export interface LectureListResponse {
    list: LectureListDto[];
    totalCnt: number;
}

export interface LectureListFilterType {
    page: number;
    limit: number;
}

// 강의 등록
export type ServeDurationType = "day" | "month" | "year";

export interface InsertLectureClassScheduleRequestDto {
    weekDay: WeekDay;
    startTime: string;
    endTime: string;
}

export interface InsertLectureClassRequestDto {
    code: string; // 상품 코드
    price: number; // 판매 가격
    priceIncludedVat: number; // 판매 가격에 포함된 부가세
    productName?: string; // 상품 이름 (미입력 시 "강의명(반명)"으로 자동 구성)
    serveDuration?: number; // 상품 제공 기간
    serveDurationType?: ServeDurationType; // 상품 제공 기간 단위
    displayDescription?: string; // 상품 노출용 설명(HTML)
    title: string;
    instructor?: string;
    instructorUserNo?: number;
    location?: string;
    capacity?: number;
    sessionCount?: number;
    recommendTarget?: string;
    startDate?: string;
    endDate?: string;
    benefitStartAt?: string; // 혜택 적용 시작일자 (2026-06-15 00:00:00)
    benefitEndAt?: string; // 혜택 적용 종료일자 (2026-06-30 23:59:59)
    schedules: InsertLectureClassScheduleRequestDto[];
}

export interface InsertLectureRequestDto {
    title: string;
    contents: string;
    description?: string;
    showStartAt?: string;
    showEndAt?: string;
    classes: InsertLectureClassRequestDto[];
}

// 강의 수정 - 기존 클래스 수정 (classNo로 지정)
export interface UpdateLectureClassRequestDto {
    classNo: number; // 수정할 클래스 고유 번호
    title?: string;
    instructor?: string;
    instructorUserNo?: number;
    location?: string;
    capacity?: number;
    sessionCount?: number;
    recommendTarget?: string;
    startDate?: string;
    endDate?: string;
    benefitStartAt?: string; // 혜택 적용 시작일자 (2026-06-15 00:00:00)
    benefitEndAt?: string; // 혜택 적용 종료일자 (2026-06-30 23:59:59)
    productName?: string; // 상품명 (상품 노출명)
    price?: number; // 판매 가격
    priceIncludedVat?: number; // 판매 가격에 포함된 부가세
    displayDescription?: string; // 상품 노출용 설명(HTML)
    schedules?: InsertLectureClassScheduleRequestDto[]; // 전달 시 기존 일정 전체 교체
}

export interface UpdateLectureRequestDto {
    title?: string;
    contents?: string;
    description?: string;
    showStartAt?: string;
    showEndAt?: string;
    classes?: UpdateLectureClassRequestDto[]; // 기존 클래스 수정 (classNo로 지정, 일부 클래스만 전달 가능)
    addClasses?: InsertLectureClassRequestDto[]; // 추가할 신규 클래스 목록
    deleteClassNos?: number[]; // 삭제할 클래스 고유 번호 목록 (수강생이 없는 경우에만 삭제됨)
}

// 강의 등록자 목록 조회
export interface LectureRegisterDto {
    orderNo: number;
    name: string;
    email: string;
    phone: string;
    paidPrice: number;
    subscriptionName: string;
    classNo: number;
    className: string;
}

export interface LectureRegisterListResponse {
    list: LectureRegisterDto[];
    totalCnt: number;
    totalSalesAmount: number;
}

export interface LectureRegisterFilterType {
    page: number;
    limit: number;
    classNo?: number;
}
